<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" id="divMainFilter">
          <div class="row">
            <div class="col-sm-8">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of volumeList" value={{item.ID}}>
                  {{item.Volume}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Issue</label>
              <select id="lstIssue" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of issueList" value={{item.ID}}>
                  {{item.Issue}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>Status</label>
              <select id="lstStatus" class="form-control select2">
                <option *ngFor="let item of statusList" value={{item.StatusName}} [selected]="item.StatusName==parameterStatus">
                  {{item.StatusName}}
                </option>
              </select>
            </div>

            <div class="col-sm-2">

              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <table #dataTable class="display" style="width:100%" id="ingestionTable"></table>

        <button type="button" id="btnPopupDT" (click)="show()" style="display:none">Show</button>
        <button type="button" id="btnDownloadDT" (click)="download()" style="display:none">Download</button>
        <button type="button" id="btnUploadDT" (click)="upload()" style="display:none">Upload</button>
        <button type="button" id="btnLoadList" (click)="getIngestionList()" style="display:none">Get</button>
        <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>

        <div id="divLogInfo" class="modal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <!-- Modal content-->
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header">
                <h4 class="modal-title">{{title}} -  {{ingestTitle}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body modalHeight">
                <div class="row">
                  <div class="col-sm-12">
                    <table class="tblMain">
                      <tbody>
                        <tr>
                          <td colspan="2" class="clsHeader">Ingestion</td>
                        </tr>
                        <tr><td>Status</td><td>{{ingestStatus}}</td></tr>
                        <tr><td>Start Date</td><td>{{ingestStartDate}}</td></tr>
                        <tr><td>Completed Date</td><td>{{ingestCompleteDate}}</td></tr>
                        <tr><td>Remarks</td><td><div class="col row" innerHTML="{{ingestDescription}}"></div></td></tr>

                        <tr><td colspan="2" class="clsHeader">Usability &amp; Completeness Check</td></tr>
                        <tr><td>Status</td><td>{{uccStatus}}</td></tr>
                        <tr><td>Start Date</td><td>{{uccStartDate}}</td></tr>
                        <tr><td>Completed Date</td><td>{{uccCompleteDate}}</td></tr>
                        <tr><td>Remarks</td><td><div class="col row" innerHTML="{{uccDescription}}"></div></td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
          </div>
        </div>

        <div id="divFileUpload" class="modal">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title">Upload package?</h3>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()" id="btnModalHide">×</button>
              </div>
              <div class="modal-body">
                <form id="submitFile">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <h5> Upload an alternative package for {{uploadTitle}}</h5>
                        <!--<input type="file" id="file" (change)="onFileChange($event)" name="httpPostedFile" value="">-->
                        <app-upload></app-upload>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
